// WU-2.4 T6 — clone of directed-notes/lib/permissions.ts for the "Evict
// operator" client affordance gate. Cosmetic only — the server is
// authoritative on supervisor.queue_evict; this only decides whether to
// render the button.
export function canQueueEvict(user: { permissions?: string[] } | null | undefined): boolean {
  return !!user?.permissions?.includes("supervisor.queue_evict") || !!user?.permissions?.includes("admin");
}
